// extracted by mini-css-extract-plugin
module.exports = {"root":"Tabs_root__EMHB6","tab":"Tabs_tab__2UW8D","tabActive":"Tabs_tabActive__As2cV"};